import { PrinciplesAdmin } from "@/components/PrinciplesAdmin"

export function PrinciplesPage() {
  return <PrinciplesAdmin />
}
